// Shared design tokens for the Decoders surface (list + control panel), mapped
// from the "UI Revamp Design Direction" §2 palette. Kept in one place so the
// grid restyle and the control-panel popover stay in lockstep across themes.

export interface ControllerTokens {
  page: string
  card: string
  elevated: string
  head: string
  line: string
  lineSoft: string
  text: string
  textHi: string
  muted: string
  faint: string
  accent: string
  accentVivid: string
  onAccent: string
  track: string
  hover: string
  chipBg: string
  chipFg: string
  warn: string
  danger: string
}

const DARK: ControllerTokens = {
  page: '#06212e',
  card: '#0d2a38',
  elevated: '#0e2c3b',
  head: '#0d2a38',
  line: '#223c48',
  lineSoft: 'rgba(255,255,255,.07)',
  text: '#EAF1F3',
  textHi: '#ffffff',
  muted: '#8A9AA3',
  faint: '#5f7885',
  accent: '#66F0A0',
  accentVivid: '#2fd3d8',
  onAccent: '#00251a',
  track: '#0a2735',
  hover: '#0a2836',
  chipBg: 'rgba(102,240,160,.14)',
  chipFg: '#66F0A0',
  warn: '#EECD1D',
  danger: '#FF6B6B',
}

const LIGHT: ControllerTokens = {
  page: '#F4F8F8',
  card: '#ffffff',
  elevated: '#ffffff',
  head: '#F4F7F7',
  line: '#E4EAEA',
  lineSoft: '#E7EBEB',
  text: '#0d2530',
  textHi: '#101828',
  muted: '#667085',
  faint: '#93a4ac',
  accent: '#004744',
  accentVivid: '#0a9bb0',
  onAccent: '#ffffff',
  track: '#EAEFEF',
  hover: '#F4F8F7',
  chipBg: '#E7F8F0',
  chipFg: '#027A48',
  warn: '#B5540A',
  danger: '#c0392b',
}

export const controllerTokens = (isDark?: boolean): ControllerTokens =>
  isDark ? DARK : LIGHT
